import { SvgIcon, SvgIconProps } from '@mui/material';

// black chevron with no background
const ChevronRightIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      viewBox="0 0 12 18"
      xmlns="http://www.w3.org/2000/svg"
      sx={{ width: 12, height: 18, fill: 'none', ...props.sx }}
      data-testid="chevronIcon"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.08579 17.4142C0.304738 16.6332 0.304738 15.3668 1.08579 14.5858L6.67157 9L1.08579 3.41421C0.304738 2.63317 0.304738 1.36684 1.08579 0.585787C1.86683 -0.195262 3.13317 -0.195262 3.91421 0.585787L10.9142 7.58579C11.6953 8.36683 11.6953 9.63317 10.9142 10.4142L3.91421 17.4142C3.13317 18.1953 1.86683 18.1953 1.08579 17.4142Z"
        fill="#0B1421"
      />
    </SvgIcon>
  );
};

export default ChevronRightIcon;
